module.exports = __webpack_public_path__ + "img/6.8e0b735d.png";